import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Session from 'supertokens-auth-react/recipe/session';

import { useApiClient } from '@eluve/api-client-provider';
import { HStack, LinkButton, NewButton } from '@eluve/components';
import {
  useIsEluveAdmin,
  useSession,
  useTenantIdFromSession,
} from '@eluve/session-helpers';
import { getCoreTenantDataQuery } from '@eluve/shared-gql-operations';

export const PendingApprovalPage: React.FC = () => {
  const apiClient = useApiClient();
  const tenantId = useTenantIdFromSession();
  const isEluveAdmin = useIsEluveAdmin();
  const session = useSession();
  const hasMultipleTenants = session.allowedTenantIds.length > 1;

  const [query] = useLazyQuery(getCoreTenantDataQuery, {
    variables: {
      tenantId: tenantId!,
    },
  });

  const navigate = useNavigate();

  const handleRetry = async () => {
    await apiClient.auth.refreshAllowedTenants();
    if (tenantId) {
      const { data } = await query();
      if ((data?.tenantsByPk?.isPendingApproval ?? true) === false) {
        navigate('/');
      }
    }
  };

  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-text-primary sm:text-5xl">
          Account Pending
        </h1>
        <p className="mt-6 text-base leading-7 text-text-tertiary">
          Thank you for signing up! Your account is pending email verification.
        </p>
        <HStack justify="center" align="center" className="mt-6">
          <NewButton onClick={handleRetry} text="Try Again" />
          {hasMultipleTenants && (
            <LinkButton
              to="/organizations"
              text="Switch Organization"
              type="subtle"
            />
          )}
          {isEluveAdmin && (
            <LinkButton to="/admin" text="Admin Dashboard" type="subtle" />
          )}
          <NewButton
            onClick={async () => {
              await Session.signOut();
              navigate('/login');
            }}
            text="Sign Out"
            type="outline"
          />
        </HStack>
      </div>
    </main>
  );
};
